// import {ActivatedRouteSnapshot, Params} from 'angular/router';

// export interface RouterStateUrl {
//     url: string;
//     params: Params;
//     queryParams: Params;
//   }
  
//   @Injectable()
//   export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {
//     serialize(routerState: RouterStateSnapshot): RouterStateUrl {
//       let route = routerState.root;
  
//       while (route.firstChild) {
//         route = route.firstChild;
//       }
  
//       const {
//         url,
//         root: { queryParams }
//       } = routerState;
//       const { params } = route;
  
//       // Only return an object including the URL, params and query params
//       // instead of the entire snapshot
//       return { url, params, queryParams };
//     }
//   }
import { Component } from '@angular/core';
import { LocationStrategy, PlatformLocation } from '@angular/common';
import { Router, UrlSerializer } from '@angular/router';

@Component({
  selector: 'hello',
  template: `
  `,
})
export class HelloComponent {
  constructor(private router: Router, private serializer: UrlSerializer) {
    const queryParams = { foo: 'a', bar: 42 };
    const tree = router.createUrlTree([], { queryParams });

    console.log(serializer.serialize(tree));
  }
}